import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";
import { ApiGetSystem, ApiUpdateSystem } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { CheckResponse, removeNonNumeric } from "utils/helpers"
import { FormCard } from "components/Cards";
import SaveButton from "components/Button/SaveButton";
import { useModal } from "components/modal/ModalContext";

export default function Tax(){
    let navigate = useNavigate()
    const {openModal, closeModal} = useModal()

    const { fetch: apiGetSystem } = useFetch(ApiGetSystem)
    const { fetch: apiUpdateSystem } = useFetch(ApiUpdateSystem)
    
    const [tax, setTax] = useState('')

    // Button Event
    const saveBtnClick = () => {
        if (tax === '') {
            openModal(ModalTypeFail, { message: 'Tax is required!' })
            return false
        }

        updateSystem().then((res) => {
            if (CheckResponse(res)) {
                openModal(ModalTypeSuccess, {
                    onSuccess: () => {
                        closeModal()
                        navigate("/setting") 
                    }
                })
            }
        })
    }

    // Function Api Call
    const getSystem = async() => {
        let res = await apiGetSystem({
            data: {
                systemKey: 'tax'
            }
        })

        return res
    }
    const updateSystem = async() => {
        let res = await apiUpdateSystem({
            data: {
                systemKey: 'tax',
                systemValue: tax,
                systemLabel: ''
            }
        })

        return res
    }

    useEffect(() => {
        openModal(ModalTypeLoading)

        getSystem().then((res) => {
            if (CheckResponse(res)) {
                setTax(res.data.systemValue)
                
                closeModal()
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    },[])

    return(
        <div className="flex flex-col gap-2 sm:p-6">
            <div>
                <span className="font-semibold text-2xl">Tax</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <FormCard title='Tax'>
                    <div className="w-24 flex gap-2 items-center">
                        <input className="input" value={tax} onChange={(e) => { setTax(removeNonNumeric(e.target.value) )}} />
                        <span>%</span>
                    </div>
                </FormCard>
            </div>

            <div className="flex w-full justify-end">
                <SaveButton visible={true} onClick={saveBtnClick} />
            </div>
        </div>
    )
}